import {UTCDate} from "@date-fns/utc";
import classNames from "classnames";
import {differenceInSeconds} from "date-fns";

import {KPICard} from "@/components/KPICard/KPICard.tsx";
import {percentage} from "@/lib/format.tsx";
import {PENDING_STATE_SECONDS} from "@/pages/checks/analysis/utils.ts";

interface StatHeaderUptimeProps {
  uptime: number;
  uptimeSLA: number;
  createdAt: string;
}

export const StatHeaderUptime = ({uptime, uptimeSLA, createdAt}: StatHeaderUptimeProps) => {
  const isReady = differenceInSeconds(new UTCDate(), createdAt) > PENDING_STATE_SECONDS;

  return (
    <KPICard title="Uptime">
      <span
        className={classNames(
          isReady
            ? {
                "text-success-brand": uptime >= (1.0 + uptimeSLA) / 2.0,
                "text-body-secondary": uptime < (1.0 + uptimeSLA) / 2.0 && uptime >= uptimeSLA,
                "check-status-down": uptime < uptimeSLA,
              }
            : "text-muted"
        )}
      >
        {!isReady && <>Gathering data</>}
        {isReady && percentage(uptime)}
      </span>
    </KPICard>
  );
};
